import React from 'react';
import {
  Button, Col, Row,
} from 'reactstrap';

import {
  Auth, Form, TextField, Intl,
} from 'components';
import { composeValidators, email, required } from 'config/InputErrors';

export default React.memo( ( { dataSubmitted, onSubmit } ) => (
  <Auth>
    {dataSubmitted
      ? (
        <div className="text-center">
          <i className="far fa-check-circle fa-4x text-gray-7 mb-3" />
          <p className="text-gray-7">
            <Intl id="forgotPasswordEmailSent" />
          </p>
        </div>
      )
      : (
        <>
          <p className="m-0">
            <Intl id="forgotPasswordTitle" />
          </p>
          <p className="text-gray-7">
            <Intl id="forgotPasswordSubtitle" />
          </p>
          <Row>
            <Col lg="5" md="7">
              <Form
                onSubmit={onSubmit}
                showErrorsInHeader
              >
                <>
                  <TextField
                    field="email"
                    validate={composeValidators( required, email )}
                    label="email"
                    labelClass="required"
                  />
                </>

                <div className="text-center mt-4">
                  <Button color="app-default" size="app-sm" className="font-weight-700">
                    <Intl id="recoverPassword" />
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </>
      )}
  </Auth>
) );
